export default class Team {
  constructor({
    id = null,
    name = null,
    pictureUrl = null,
    playersUpdatedAt = null,
    slug = null,
    updatedAt = null,
  } = {}) {
    this.id = id;
    this.name = name;
    this.pictureUrl = pictureUrl;
    this.playersUpdatedAt = playersUpdatedAt ? new Date(playersUpdatedAt) : null;
    this.slug = slug;
    this.updatedAt = updatedAt ? new Date(updatedAt) : null;
  }

  static createFromObject(data) {
    return new Team(data);
  }

  static createCollectionFromObject(data) {
    return data.map(
      (teamData) => Team.createFromObject(teamData),
    );
  }
}
